import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { PaymentButtonComponent } from '../../components/payment-button/payment-button.component';
import { CartPaymentMethods } from '../../core/enums/CartPaymentMethods';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-payment-method-picker-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    PaymentButtonComponent,
    NgTemplateOutlet
  ],
  templateUrl: './payment-method-picker-modal.component.html',
  styleUrl: './payment-method-picker-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodPickerModalComponent extends BaseModalComponent {

  @Input() showVoucherOutOption = false;

  @Output() confirm = new EventEmitter<{ cartPaymentMethod: CartPaymentMethods; }>();

  public selectedPaymentMethod: CartPaymentMethods;
  public readonly cartPaymentMethods = CartPaymentMethods;
  public readonly isPaymentMethodDisabledMap = computed<Partial<Record<CartPaymentMethods, boolean>>>(() => ({
    [CartPaymentMethods.Cash]: !this.terminalsStore.isPaymentMethodAllowed(CartPaymentMethods.CashOut),
    [CartPaymentMethods.Card]: !this.terminalsStore.isPaymentMethodAllowed(CartPaymentMethods.CardOut),
    [CartPaymentMethods.Invoice]: !this.terminalsStore.isPaymentMethodAllowed(CartPaymentMethods.InvoiceOut)
  }));

  public override open(val?: null): void {
    this.selectedPaymentMethod = null;
    super.open(val);
  }

  public confirmSelectedPaymentMethod(): void {
    if (!this.selectedPaymentMethod || this.isPaymentMethodDisabledMap()[this.selectedPaymentMethod]) {
      return;
    }

    this.confirm.emit({ cartPaymentMethod: this.selectedPaymentMethod });
    this.close();
  }
}
